module.exports = __webpack_public_path__ + "static/img/poster_sl01.6ceab3c7.jpg";